import { render, staticRenderFns } from "./ConfirmNotification.vue?vue&type=template&id=43610074&scoped=true&"
import script from "./ConfirmNotification.vue?vue&type=script&lang=js&"
export * from "./ConfirmNotification.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmNotification.vue?vue&type=style&index=0&id=43610074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43610074",
  null
  
)

export default component.exports